import React, { useEffect, useState, useRef } from "react";
import { DateTime } from "luxon";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { OverlayPanel } from "primereact/overlaypanel";
import { Card } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { getAccountingHeadJournal } from "../../../../services/finance/accountingJournal";
import { formatDate } from "../../../../utils/utils";
import ContentLayout from "../../../../partials/content/ContentLayout";
import NumberFormat from "react-number-format";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import JournalEntryDetail from "./JournalEntryDetail";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import Illustration from "../../../../partials/content/Illustration";

function JournalEntriesList({ history }) {
  const { reload } = useGlobalData();
  const selectParamOp = useRef(null);
  const [selectParam, setSelectParam] = useState({
    dateFrom: DateTime.now().startOf("month"),
    dateTo: DateTime.now().endOf("month"),
  });
  const [accountingHead, setAccountingHead] = useState([]);
  const [openJournalDetail, setOpenJournalDetail] = useState(false);
  const [journalID, setJournalID] = useState(0);

  useEffect(() => {
    getAccountingHeadJournalData();
  }, [reload]);

  const journalEntryDetailColumn = [
    {
      header: "Document Reference ID",
      field: "docRefID",
      type: "string",
    },
    {
      header: "Reversal Journal ID",
      field: "revJournalID",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];
  return (
    <ContentLayout>
      <PageSubHeader
        title="Accounting Journal Entry List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/journal-entries",
            title: "Accounting Journal Entries",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
          {
            title: "New Journal Entry",
            color: "primary",
            icon: "fas fa-plus-circle",
            onClick: () => {
              history.push("/finance/journal-entry-form");
            },
          },
        ]}
      />
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date From"
                      autoOk
                      clearable
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateFrom}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateFrom = date;
                        setSelectParam(selectParamTmp);
                      }}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date To"
                      autoOk
                      clearable
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateTo}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateTo = date;
                        setSelectParam(selectParamTmp);
                      }}
                      minDate={selectParam.dateFrom}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                getAccountingHeadJournalData();
              }}
            >
              <i className="fas fa-search"></i>
              Get Accounting Journal
            </button>
          </div>
        </div>
      </OverlayPanel>
      {accountingHead.length ? (
        <React.Fragment>
          <CustomDataTable
            data={accountingHead}
            dataDetailColumns={journalEntryDetailColumn}
            onRefreshData={() => {
              getAccountingHeadJournalData();
            }}
            buttons={[
              {
                name: "Filter",
                onClick: (e) => {
                  selectParamOp.current.toggle(e);
                },
                icon: "fas fa-search",
                color: "info",
              },
            ]}
            columns={[
              {
                header: "Accounting Journal ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Document Type",
                field: "docTypeDesc",
                body: (rowData) => {
                  if (rowData.docType === 1) {
                    return (
                      <Badge variant="primary">{rowData.docTypeDesc}</Badge>
                    );
                  } else if (rowData.docType === 2) {
                    return (
                      <Badge variant="success">{rowData.docTypeDesc}</Badge>
                    );
                  } else if (rowData.docType === 3) {
                    return (
                      <Badge variant="danger">{rowData.docTypeDesc}</Badge>
                    );
                  } else if (rowData.docType === 4) {
                    return <Badge variant="info">{rowData.docTypeDesc}</Badge>;
                  } else {
                    return <Badge variant="dark">{rowData.docTypeDesc}</Badge>;
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Document Reference",
                field: "docRef",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Document Date",
                field: "documentDate",
                body: (rowData) => formatDate(rowData.documentDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Amount",
                field: "totalAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.totalAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">{value}</div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Accounting Journal Entry Detail">
                      <button
                        type="button"
                        onClick={() => {
                          setJournalID(rowData.ID);
                          setOpenJournalDetail(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Payment.png"
            description={`You don't have any Journal Entries for current data selection!`}
            guidance={`Hint: Try to filter another data selection to get some results`}
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-info btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                selectParamOp.current.toggle(e);
              }}
            >
              <i className="fas fa-search"></i>
              Filter
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openJournalDetail}
        title="Accounting Journal Entry Detail"
        onCloseDialog={() => {
          setOpenJournalDetail(false);
        }}
        maxWIdth="lg"
      >
        <JournalEntryDetail
          journalID={journalID}
          onReserveSave={() => {
            getAccountingHeadJournalData();
            setOpenJournalDetail(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenJournalDetail(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </ContentLayout>
  );

  async function getAccountingHeadJournalData() {
    const response = await getAccountingHeadJournal(
      selectParam.dateFrom,
      selectParam.dateTo
    );
    const { data } = response.data;
    setAccountingHead(data.accountingHead);
  }
}

export default JournalEntriesList;
